module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/promo/9-b4bcec8bd8686002ec52915db46d599f.png";